





































































































































































































































































































































































































































































































































import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import UploadWithErrorsBlock from '@/components/UI/UploadWithErrorsBlock.vue';
import '@/extensions';
import {TableHeaders} from '@/interfaces/components-data';
import {SelectBox} from '@/interfaces/global-data';
import {
  OmnichannelFixedGapType,
  OmnichannelStrategy,
  ImportUploadOption,
  Sort
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {
    IOmnichannelStrategyDto,
    IOmnichannelStrategyFilters,
    IOmnichannelStrategyQuery,
    IOmnichannelStrategyQueryDto,
    IOmnichannelStrategySaveDto,
    IOmnichannelStrategyTableDto,
    IOmnichannelStrategyTableElementDto,
    IOmnichannelStrategyFilterOptions,
    OmnichannelFixedDiffTypeSelectBox,
    OmnichannelStrategiesOptionsType,
} from '@/pages/omnichannel-strategy/types/data';
import {FixedDiffParams, IStrategyParamsDto} from '@/pages/omnichannel-strategy/types/FixedDiffParams';
import OmnichannelStrategyApi from '@/pages/omnichannel-strategy/api/OmnichannelStrategyApi';
import {OptimalDiffParams} from '@/pages/omnichannel-strategy/types/OptimalDiffParams';
import { EqualityParams } from '@/pages/omnichannel-strategy/types/EqualityParams';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import { Modal } from 'ant-design-vue';
import vSelect from '@/components/UI/vSelect.vue';

@Component({
    components: {
        vSelect,
        CollapseCard,
        Card,
        UploadWithErrorsBlock,
    },
})
export default class OmnichannelStrategyTable extends Mixins(LocalData, Http) {
    @Prop({required: true}) readonly filters!: IOmnichannelStrategyFilters;
    @Prop({required: true}) readonly api!: OmnichannelStrategyApi

    private omnichannelStrategiesSet: OmnichannelStrategiesOptionsType = {
        PRICE_EQUALITY: {
            value: OmnichannelStrategy.PRICE_EQUALITY,
            label: this.$tc('omnichannelStrategy.strategies.PRICE_EQUALITY'),
        },
        FIXED_DIFFERENCE: {
            value: OmnichannelStrategy.FIXED_DIFFERENCE,
            label: this.$tc('omnichannelStrategy.strategies.FIXED_DIFFERENCE'),
        },
        OPTIMAL_DIFFERENCE_ML: {
            value: OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML,
            label: this.$tc('omnichannelStrategy.strategies.OPTIMAL_DIFFERENCE_ML'),
        },
    };

    private omnichannelFixedDiffTypeSelectBox: OmnichannelFixedDiffTypeSelectBox = {
        GREATER_THAN: {
            value: OmnichannelFixedGapType.GREATER_THAN,
            label: this.$tc('omnichannelStrategy.fixedGapTypes.GREATER_THAN'),
        },
        LESS_THAN: {
            value: OmnichannelFixedGapType.LESS_THAN,
            label: this.$tc('omnichannelStrategy.fixedGapTypes.LESS_THAN'),
        },
        NOT_GREATER_THAN: {
            value: OmnichannelFixedGapType.NOT_GREATER_THAN,
            label: this.$tc('omnichannelStrategy.fixedGapTypes.NOT_GREATER_THAN'),
        },
        NOT_LESS_THAN: {
            value: OmnichannelFixedGapType.NOT_LESS_THAN,
            label: this.$tc('omnichannelStrategy.fixedGapTypes.NOT_LESS_THAN'),
        },
        FIX_GAP: {
          value: OmnichannelFixedGapType.FIX_GAP,
          label: this.$tc('omnichannelStrategy.fixedGapTypes.FIX_GAP'),
        },
    }

    private needLoadFiltersForTable: boolean = true;
    private lastFilterOptionsQueryKey: string | null = null;

    private defaultFilterValue = {value: -1, label: this.$tc('shared.selectBox.all')};
    private defaultStringFiltersValue = {value: null, label: this.$tc('shared.selectBox.all')};

    private sortingFields: Sort[] = [];
    private lastSortedColumnKey: string | null = null;
    private lastSortedOrder: string | null = null;

    errorsAmount: number = 0
    tableLoading: boolean = false;

    private selectCategoryFilter: SelectBox<number> = this.defaultFilterValue;
    private categoryFilterOptions: Array<SelectBox<number>> = [];

    private selectGroupFilter: SelectBox<number> = this.defaultFilterValue;
    private groupFilterOptions: Array<SelectBox<number>> = [];

    private selectSubcategoryFilter: SelectBox<number> = this.defaultFilterValue;
    private subcategoryFilterOptions: Array<SelectBox<number>> = [];

    private selectDependFormatFilter: number = this.defaultFilterValue.value;
    private formatDependFilterOptions: Array<SelectBox<number>> = [];

    private selectBaseFormatFilter: number = this.defaultFilterValue.value;
    private formatBaseFilterOptions: Array<SelectBox<number>> = [];

    private selectBaseRegionFilter: number = this.defaultFilterValue.value;
    private regionBaseFilterOptions: Array<SelectBox<number>> = [];

    private selectBaseClusterFilter: number = this.defaultFilterValue.value;
    private clusterBaseFilterOptions: Array<SelectBox<number>> = [];

    private selectDependRegionFilter: number = this.defaultFilterValue.value;
    private regionDependFilterOptions: Array<SelectBox<number>> = [];

    private selectDependClusterFilter: number = this.defaultFilterValue.value;
    private clusterDependFilterOptions: Array<SelectBox<number>> = [];

    private selectOmnichannelGap: number = this.defaultFilterValue.value;
    private gapFilterOptions: Array<SelectBox<number>> = [];

    private selectApplyForPriceSegments: boolean | null = this.defaultStringFiltersValue.value;
    private applyForPriceSegmentsFilterOptions: Array<SelectBox<boolean | null>> = [];

    private selectApplyCompetitorPrices: boolean | null = this.defaultStringFiltersValue.value;
    private applyCompetitorPricesFilterOptions: Array<SelectBox<boolean | null>> = [];

    private selectApplyMinProfitabilityLimit: boolean | null = this.defaultStringFiltersValue.value;
    private applyMinProfitabilityLimitFilterOptions: Array<SelectBox<boolean | null>> = [];

    private selectOmnichannelTypeFilter: OmnichannelFixedGapType | null = this.defaultStringFiltersValue.value;
    private typeFilterOptions: Array<SelectBox<OmnichannelFixedGapType | null>> = [];

    private selectOmnichannelTopEdgeFilter: number = this.defaultFilterValue.value;
    private topEdgeFilterOptions: Array<SelectBox<number>> = [];

    private selectOmnichannelBottomEdgeFilter: number = this.defaultFilterValue.value;
    private bottomEdgeFilterOptions: Array<SelectBox<number>> = [];

    private selectOmnichannelDepthFilter: number = this.defaultFilterValue.value;
    private depthFilterOptions: Array<SelectBox<number>> = [];

    private selectOmnichannelStrategy: OmnichannelStrategy | null = this.defaultStringFiltersValue.value;
    // private omnichannelFilterOptions: Array<SelectBox<OmnichannelStrategy>> = [];
    private omnichannelStrategyFilterOptions: Array<SelectBox<OmnichannelStrategy | null>> = [
        {value: null, label: this.$tc('shared.selectBox.all')},
        {
            value: OmnichannelStrategy.FIXED_DIFFERENCE,
            label: this.$tc('omnichannelStrategy.strategies.FIXED_DIFFERENCE'),
        },
        {
            value: OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML,
            label: this.$tc('omnichannelStrategy.strategies.OPTIMAL_DIFFERENCE_ML'),
        },
        {
            value: OmnichannelStrategy.PRICE_EQUALITY,
            label: this.$tc('omnichannelStrategy.strategies.PRICE_EQUALITY'),
        },
    ];

    private omnichannelCurrentPage: number = 1;
    private omnichannelTotalRows: number = 0;
    private omnichannelPerPage: number = 20;
    private refreshOmnicalListId: number = -1;
    private tableKey: number = 0;
    private tableFields: TableHeaders[] = [
        {key: 'id', label: this.$tc('omnichannelStrategy.table.headers.id')},
        {
            key: 'groupOfProduct.name',
            label: this.$tc('omnichannelStrategy.table.headers.group'),
            thClass: ['strategyHeaders'],
            formatter: this.nameFormatter,
        },
        {
            key: 'productCategory.name',
            label: this.$tc('omnichannelStrategy.table.headers.category'),
            thClass: ['strategyHeaders'],
            formatter: this.nameFormatter,
        },
        {
            key: 'subcategory.name',
            label: this.$tc('omnichannelStrategy.table.headers.subcategories'),
            thClass: ['strategyHeaders'],
            formatter: this.nameFormatter,
        },
        {
            key: 'baseStoreParams.format.name',
            label: this.$tc('omnichannelStrategy.table.headers.formatChannelOne'),
            thClass: ['strategyHeaders'],
        },
        {
            key: 'baseStoreParams.region.name',
            label: this.$tc('omnichannelStrategy.table.headers.regionOne'),
            thClass: ['strategyHeaders'],
            formatter: this.nameFormatter,
        },
        {
            key: 'baseStoreParams.cluster.name',
            label: this.$tc('omnichannelStrategy.table.headers.clusterOne'),
            thClass: ['strategyHeaders'],
            formatter: this.nameFormatter,
        },
        {
            key: 'dependStoreParams.format.name',
            label: this.$tc('omnichannelStrategy.table.headers.formatChannelTwo'),
            thClass: ['strategyHeaders'],
        },
        {
            key: 'dependStoreParams.region.name',
            label: this.$tc('omnichannelStrategy.table.headers.regionTwo'),
            thClass: ['strategyHeaders'],
            formatter: this.nameFormatter,
        },
        {
            key: 'dependStoreParams.cluster.name',
            label: this.$tc('omnichannelStrategy.table.headers.clusterTwo'),
            thClass: ['strategyHeaders'],
            formatter: this.nameFormatter,
        },
        {
            key: 'strategy',
            label: this.$tc('omnichannelStrategy.table.headers.strategy'),
            formatter: (data: OmnichannelStrategy) => this.omnichannelStrategiesSet[data].label,
        },
        {
            key: 'strategyParams.type',
            label: this.$tc('omnichannelStrategy.table.headers.type'),
            formatter: (data: OmnichannelFixedGapType) => this.omnichannelFixedDiffTypeSelectBox[data] ? this.omnichannelFixedDiffTypeSelectBox[data].label : '',
        },
        {
            key: 'strategyParams.gap',
            label: this.$tc('omnichannelStrategy.table.headers.gap'),
        },
        {
            key: 'strategyParams.applyForPriceSegments',
            label: this.$tc('omnichannelStrategy.table.headers.applyForPriceSegment'),
            formatter: (data: boolean) => this.toYesOrNoOmnichannel(data),
        },
        {
            key: 'strategyParams.applyCompetitorPrices',
            label: this.$tc('omnichannelStrategy.table.headers.applyCompetitorPrices'),
            formatter: (data: boolean) => this.toYesOrNoOmnichannel(data),
        },
        {
            key: 'strategyParams.applyMinProfitabilityLimit',
            label: this.$tc('omnichannelStrategy.table.headers.applyMinProfitabilityLimit'),
            formatter: (data: boolean) => this.toYesOrNoOmnichannel(data),
        },
        {key: 'strategyParams.bottomEdge', label: this.$tc('omnichannelStrategy.table.headers.bottomEdge')},
        {key: 'strategyParams.topEdge', label: this.$tc('omnichannelStrategy.table.headers.topEdge')},
        {key: 'strategyParams.depth', label: this.$tc('omnichannelStrategy.table.headers.depth')},
        {key: 'actions', label: this.$tc('shared.labels.actions'), thClass: ['strategyHeaders']},
    ];

    private newTableFields: any[] = [
        {
            dataIndex: 'id', title: this.$tc('omnichannelStrategy.table.headers.id'),
            width: 100,
            fixed: 'left',
        },
        {
            dataIndex: 'groupOfProduct.name',
            title: this.$tc('omnichannelStrategy.table.headers.group'),
            sorter: true,
            customRender: this.nameFormatter,
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'productCategory.name',
            title: this.$tc('omnichannelStrategy.table.headers.category'),
            sorter: true,
            customRender: this.nameFormatter,
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'subcategory.name',
            title: this.$tc('omnichannelStrategy.table.headers.subcategories'),
            sorter: true,
            customRender: this.nameFormatter,
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'baseStoreParams.format.name',
            title: this.$tc('omnichannelStrategy.table.headers.formatChannelOne'),
            sorter: true,
            width: 200,
            scopedSlots: {
                filterDropdown: 'formatFilter',
                filterIcon: "formatFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'baseStoreParams.region.name',
            title: this.$tc('omnichannelStrategy.table.headers.regionOne'),
            sorter: true,
            customRender: this.nameFormatter,
            width: 200,
            scopedSlots: {
                filterDropdown: 'regionFilter',
                filterIcon: "regionFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'baseStoreParams.cluster.name',
            title: this.$tc('omnichannelStrategy.table.headers.clusterOne'),
            sorter: true,
            customRender: this.nameFormatter,
            width: 200,
            scopedSlots: {
                filterDropdown: 'clusterFilter',
                filterIcon: "clusterFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'dependStoreParams.format.name',
            title: this.$tc('omnichannelStrategy.table.headers.formatChannelTwo'),
            sorter: true,
            width: 200,
            scopedSlots: {
                filterDropdown: 'format2Filter',
                filterIcon: "format2FilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'dependStoreParams.region.name',
            title: this.$tc('omnichannelStrategy.table.headers.regionTwo'),
            sorter: true,
            customRender: this.nameFormatter,
            width: 200,
            scopedSlots: {
                filterDropdown: 'region2Filter',
                filterIcon: "region2FilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'dependStoreParams.cluster.name',
            title: this.$tc('omnichannelStrategy.table.headers.clusterTwo'),
            sorter: true,
            customRender: this.nameFormatter,
            width: 200,
            scopedSlots: {
                filterDropdown: 'cluster2Filter',
                filterIcon: "cluster2FilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategy',
            title: this.$tc('omnichannelStrategy.table.headers.strategy'),
            customRender: (data: OmnichannelStrategy) => this.omnichannelStrategiesSet[data].label,
            sorter: true,
            width: 200,
            scopedSlots: {
                filterDropdown: 'strategyFilter',
                filterIcon: "strategyFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategyParams.type',
            title: this.$tc('omnichannelStrategy.table.headers.type'),
            sorter: true,
            customRender: (data: OmnichannelFixedGapType) => this.omnichannelFixedDiffTypeSelectBox[data] ? this.omnichannelFixedDiffTypeSelectBox[data].label : '',
            width: 200,
            scopedSlots: {
                filterDropdown: 'typeFilter',
                filterIcon: "typeFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategyParams.gap',
            sorter: true,
            title: this.$tc('omnichannelStrategy.table.headers.gap'),
            width: 200,
            scopedSlots: {
                filterDropdown: 'gapFilter',
                filterIcon: "gapFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategyParams.applyForPriceSegments',
            sorter: true,
            title: this.$tc('omnichannelStrategy.table.headers.applyForPriceSegment'),
            customRender: (data: boolean) => this.toYesOrNoOmnichannel(data),
            width: 300,
            scopedSlots: {
                filterDropdown: 'applyForPriceSegmentsFilter',
                filterIcon: "applyForPriceSegmentsFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategyParams.applyCompetitorPrices',
            sorter: true,
            title: this.$tc('omnichannelStrategy.table.headers.applyCompetitorPrices'),
            customRender: (data: boolean) => this.toYesOrNoOmnichannel(data),
            width: 300,
            scopedSlots: {
                filterDropdown: 'applyCompetitorPricesFilter',
                filterIcon: "applyCompetitorPricesIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategyParams.applyMinProfitabilityLimit',
            sorter: true,
            title: this.$tc('omnichannelStrategy.table.headers.applyMinProfitabilityLimit'),
            customRender: (data: boolean) => this.toYesOrNoOmnichannel(data),
            width: 300,
            scopedSlots: {
                filterDropdown: 'applyMinProfitabilityLimitFilter',
                filterIcon: "applyMinProfitabilityLimitIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategyParams.bottomEdge',
            title: this.$tc('omnichannelStrategy.table.headers.bottomEdge'),
            sorter: true,
            width: 250,
            scopedSlots: {
                filterDropdown: 'bottomEdgeFilter',
                filterIcon: "bottomEdgeFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategyParams.topEdge',
            title: this.$tc('omnichannelStrategy.table.headers.topEdge'),
            sorter: true,
            width: 200,
            scopedSlots: {
                filterDropdown: 'topEdgeFilter',
                filterIcon: "topEdgeFilterIcon"
            },
            ellipsis: true,
        },
        {
            dataIndex: 'strategyParams.depth',
            title: this.$tc('omnichannelStrategy.table.headers.depth'),
            sorter: true,
            width: 200,
            scopedSlots: {
                filterDropdown: 'depthFilter',
                filterIcon: "depthFilterIcon"
            },
            ellipsis: true,
        },
        {dataIndex: 'actions', title: this.$tc('shared.labels.actions'), scopedSlots: { customRender: 'actions' },sorter: true, fixed: 'right', width: 120},
    ];

    pagination = {
      current: 1,
      pageSize: 20,
      total: 0
    }

    tableItems: IOmnichannelStrategyTableElementDto[] = [];
    private selectedStrategyIds: number[] = [];
    private selectedStrategiesById: Map<number, IOmnichannelStrategyTableElementDto> = new Map();

    get rowSelection() {
        return {
            selectedRowKeys: this.selectedStrategyIds,
            onChange: (selectedRowKeys: number[], selectedRows: IOmnichannelStrategyTableElementDto[]) => {
                const selectedKeysSet = new Set(selectedRowKeys);
                this.selectedStrategyIds = selectedRowKeys;

                Array.from(this.selectedStrategiesById.keys()).forEach((strategyId) => {
                    if (!selectedKeysSet.has(strategyId)) {
                        this.selectedStrategiesById.delete(strategyId);
                    }
                });

                selectedRows.forEach((row) => {
                    if (row.id != null) {
                        this.selectedStrategiesById.set(row.id, row);
                    }
                });

                this.emitSelectionChange();
            },
        };
    }

    clearSelection() {
        this.selectedStrategyIds = [];
        this.selectedStrategiesById.clear();
        this.emitSelectionChange();
    }

    private emitSelectionChange() {
        this.$emit('selectionChange', Array.from(this.selectedStrategiesById.values()));
    }

    private customTableRow(record: IOmnichannelStrategyTableElementDto) {
        return {
            on: {
                click: (event: MouseEvent) => {
                    const target = event.target as HTMLElement | null;
                    if (target && (target.closest('.ant-checkbox-wrapper') || target.closest('.ant-checkbox'))) {
                        return;
                    }
                    this.goToProductList(record);
                },
            },
            class: 'omnichannel-strategy-row-clickable',
        };
    }

    private queryParams: IOmnichannelStrategyQuery = {
        tradingNetId: this.filters.market == null ? -1 : this.filters.market.id,
        groupId: this.selectGroupFilter.value,
        categoryId: this.selectCategoryFilter.value,
        subcategoryId: this.selectSubcategoryFilter.value,
        baseStoreParams: {
            clusterId: this.selectBaseClusterFilter,
            formatId: this.selectBaseFormatFilter,
            regionId: this.selectBaseRegionFilter,
        },
        dependStoreParams: {
            clusterId: this.selectDependClusterFilter,
            formatId: this.selectDependFormatFilter,
            regionId: this.selectDependRegionFilter,
        },
        strategy: this.selectOmnichannelStrategy,
        strategyParams: null,
        sort: [{field: '', asc: true}],
        page: 1,
        size: this.omnichannelTotalRows,
    }

    onTableChange(pagination: any, _: any, sort: any) {

      // 1. обновляем пагинацию
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize
      };

      // Получаем колонку и направление
      const col = sort && sort.columnKey ? sort.columnKey : null;
      const order = sort ? sort.order : null;

      const sortingChanged =
          col && (
              col !== this.lastSortedColumnKey ||
              order !== this.lastSortedOrder
          );

      // 2. Это сортировка
      if (sortingChanged) {
        this.lastSortedColumnKey = col;
        this.lastSortedOrder = order;
        this.onHeadClicked(col, order);
        return;
      }

      // 3. Это пагинация
      this.$nextTick(() => {
        this.fetchStrategies({}, () => {});
      });
    }

    show(value: any, key: string, item: IOmnichannelStrategyTableElementDto, formatter?: (data: any) => any): any | null {
        if (formatter != null) {
            return formatter(this)
        } else {
            return value
        }
    }

    private nameFormatter(name: string | null): string {
        if (name != null) {
            return name
        }
        return this.$tc('shared.selectBox.all');
    }

    private getFilters(_: any): IOmnichannelStrategyQueryDto {
        return {
            tradingNetId: this.filters.market == null ? -1 : this.filters.market.id,
            groupId: this.filters.groupOfProduct,
            categoryId: this.filters.categoryOfProduct,
            subcategoryId: this.filters.subcategory,
            baseStoreParams: {
                clusterId: this.selectBaseClusterFilter,
                formatId: this.selectBaseFormatFilter,
                regionId: this.selectBaseRegionFilter,
            },
            dependStoreParams: {
                clusterId: this.selectDependClusterFilter,
                formatId: this.selectDependFormatFilter,
                regionId: this.selectDependRegionFilter,
            },
            strategy: this.selectOmnichannelStrategy,
            strategyParams: this.setQueryStrategyParams(),
            sort: this.sortingFields,
            page: this.pagination.current - 1,
            size: this.pagination.pageSize,
        }
    }

    private setQueryStrategyParams(): IStrategyParamsDto {
        return {
            type: this.selectOmnichannelTypeFilter,
            gap: this.selectOmnichannelGap,
            applyForPriceSegments: this.selectApplyForPriceSegments,
            applyCompetitorPrices: this.selectApplyCompetitorPrices,
            applyMinProfitabilityLimit: this.selectApplyMinProfitabilityLimit,
            bottomEdge: this.selectOmnichannelBottomEdgeFilter,
            depth: this.selectOmnichannelDepthFilter,
            topEdge: this.selectOmnichannelTopEdgeFilter,
        }
    }

    mounted() {
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchStrategies({}, () => {})
    }

    private onHeadClicked(key: string, order: 'ascend' | 'descend' | null) {
      // Маппинг ключа из колонки → имя поля сортировки
      const map: Record<string, string> = {
        'groupOfProduct.name': 'groupOfProduct',
        'productCategory.name': 'productCategory',
        'subcategory.name': 'subcategory',

        'baseStoreParams.format.name': 'baseStoreFormat',
        'baseStoreParams.region.name': 'baseStoreRegion',
        'baseStoreParams.cluster.name': 'baseStoreCluster',

        'dependStoreParams.format.name': 'dependStoreFormat',
        'dependStoreParams.region.name': 'dependStoreRegion',
        'dependStoreParams.cluster.name': 'dependStoreCluster',

        'strategyParams.depth': 'depth',
        'strategyParams.topEdge': 'topEdge',
        'strategyParams.bottomEdge': 'bottomEdge',
        'strategyParams.type': 'type',
        'strategyParams.applyForPriceSegments': 'applyForPriceSegments',
        'strategyParams.applyCompetitorPrices': 'applyCompetitorPrices',
        'strategyParams.applyMinProfitabilityLimit': 'applyMinProfitabilityLimit',
        'strategyParams.gap': 'gap',

        'strategy': 'strategy'
      };

      const field = map[key];
      if (!field) return;

      // переводим AntD → наше состояние
      let nextState: boolean | null = null;

      if (order === 'ascend') nextState = true;
      else if (order === 'descend') nextState = false;
      else nextState = null;

      const arrowKey = 'showSortingArrow' + field.charAt(0).toUpperCase() + field.slice(1);

      // Обновляем стрелку
      (this as any)[arrowKey] = nextState;

      // Обновляем поля сортировки
      if (nextState === null) {
        this.sortingFields = [];
      } else {
        this.sortingFields = [{ field, asc: nextState }];
      }

      // Очищаем стрелки всех остальных колонок
      Object.keys(map).forEach(k => {
        const f = map[k];
        if (f !== field) {
          const aKey = 'showSortingArrow' + f.charAt(0).toUpperCase() + f.slice(1);
          (this as any)[aKey] = null;
        }
      });

      // Перезагружаем таблицу
      this.refreshOmnicalStrategyListBySelectedFilters();
    }



    private toYesOrNoOmnichannel(value: boolean | null): string {
            if (value === null) {
                return ' '
            } else if (value) {
                return this.$tc('shared.actions.yes')
            } else {
                return this.$tc('shared.actions.no')
            }
        }

    private clearOmnicalStrategyFilters() {
        this.clearSelection();
        this.selectCategoryFilter = this.defaultFilterValue;
        this.selectGroupFilter = this.defaultFilterValue;
        this.selectSubcategoryFilter = this.defaultFilterValue;
        this.selectBaseClusterFilter = this.defaultFilterValue.value;
        this.selectBaseRegionFilter = this.defaultFilterValue.value;
        this.selectBaseFormatFilter = this.defaultFilterValue.value;
        this.selectDependFormatFilter = this.defaultFilterValue.value;
        this.selectDependRegionFilter = this.defaultFilterValue.value;
        this.selectDependClusterFilter = this.defaultFilterValue.value;
        this.queryParams.categoryId = -1;
        this.queryParams.groupId = -1;
        this.queryParams.subcategoryId = -1;
        this.queryParams.baseStoreParams.formatId = -1;
        this.queryParams.baseStoreParams.regionId = -1;
        this.queryParams.baseStoreParams.clusterId = -1;
        this.selectOmnichannelStrategy = this.defaultStringFiltersValue.value
        this.selectOmnichannelTypeFilter = this.defaultStringFiltersValue.value
        this.selectOmnichannelDepthFilter = this.defaultFilterValue.value
        this.selectOmnichannelGap = this.defaultFilterValue.value
        this.selectOmnichannelTopEdgeFilter = this.defaultFilterValue.value
        this.selectOmnichannelBottomEdgeFilter = this.defaultFilterValue.value
        this.selectApplyForPriceSegments = this.defaultStringFiltersValue.value
        this.selectApplyCompetitorPrices = this.defaultStringFiltersValue.value
        this.selectApplyMinProfitabilityLimit = this.defaultStringFiltersValue.value
        this.needLoadFiltersForTable = true
        this.lastFilterOptionsQueryKey = null

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;

        this.fetchStrategies({}, () => {});
    }

    private refreshOmnicalStrategyListBySelectedFilters() {
        // this.needLoadFiltersForTable = true;
        this.pagination = {
          ...this.pagination,
          current: 1
        };
        this.fetchStrategies({}, () => {});
    }

    private applyTableFilter(confirm: () => void) {
        confirm();
        this.refreshOmnicalStrategyListBySelectedFilters();
    }

    @Watch('filters', {deep: true})
    private onFiltersChanged(newVal: IOmnichannelStrategyFilters, _: IOmnichannelStrategyFilters) {
        if (typeof newVal !== 'undefined') {
            this.clearSelection();
            if (newVal.market != null) {
                this.queryParams.tradingNetId = newVal.market.id
                this.fetchStrategies({}, () => {});
            } else {
                this.queryParams.tradingNetId = null;
            }
            this.queryParams.groupId = newVal.groupOfProduct;
            this.queryParams.categoryId = newVal.categoryOfProduct;
            this.queryParams.subcategoryId = newVal.subcategory;
        }
    }

    private async fetchStrategies(ctx: any, callback: (items: IOmnichannelStrategyTableElementDto[]) => void) {
      const filters = this.filters;
      if (filters.market == null) {
        callback([]);
        return;
      }

      this.tableLoading = true;
      try {
        const resp = await this.api.fetchStrategies(this.getFilters(ctx));

        if (!(resp.status === 200)) {
          callback([]);
          return;
        }

        this.pagination = { ...this.pagination, total: resp.data.totalElements };

        const items = resp.data.content.map(e => this.mapRow(e));
        this.tableItems = items;
        callback(items);
      } finally {
        this.tableLoading = false;
      }

      if (this.shouldLoadFilterOptions()) {
        this.loadTableFilterOptions();
      }
    }

    private getFilterOptionsQueryKey(): string {
      return [
        this.filters.market ? this.filters.market.id : null,
        this.filters.groupOfProduct,
        this.filters.categoryOfProduct,
        this.filters.subcategory,
      ].join('-');
    }

    private shouldLoadFilterOptions(): boolean {
      return this.needLoadFiltersForTable || this.lastFilterOptionsQueryKey !== this.getFilterOptionsQueryKey();
    }

    private getFilterOptionsQuery() {
      return {
        tradingNetId: this.filters.market ? this.filters.market.id : -1,
        groupId: this.filters.groupOfProduct >= 0 ? this.filters.groupOfProduct : null,
        categoryId: this.filters.categoryOfProduct >= 0 ? this.filters.categoryOfProduct : null,
        subcategoryId: this.filters.subcategory >= 0 ? this.filters.subcategory : null,
      };
    }

    private async loadTableFilterOptions() {
      if (!this.filters.market) {
        return;
      }

      const queryKey = this.getFilterOptionsQueryKey();
      this.needLoadFiltersForTable = false;
      this.clearFilterOptions();

      try {
        const resp = await this.api.fetchFilterOptions(this.getFilterOptionsQuery());
        if (resp.status === 200) {
          this.applyFilterOptionsFromApi(resp.data);
          this.lastFilterOptionsQueryKey = queryKey;
        }
      } catch (_) {
        this.lastFilterOptionsQueryKey = null;
      }
    }

    private applyFilterOptionsFromApi(data: IOmnichannelStrategyFilterOptions) {
      this.groupFilterOptions = this.toNumberFilterOptions(data.groups);
      this.categoryFilterOptions = this.toNumberFilterOptions(data.categories);
      this.subcategoryFilterOptions = this.toNumberFilterOptions(data.subcategories);
      this.formatBaseFilterOptions = this.toNumberFilterOptions(data.baseFormats);
      this.regionBaseFilterOptions = this.toNumberFilterOptions(data.baseRegions);
      this.clusterBaseFilterOptions = this.toNumberFilterOptions(data.baseClusters);
      this.formatDependFilterOptions = this.toNumberFilterOptions(data.dependFormats);
      this.regionDependFilterOptions = this.toNumberFilterOptions(data.dependRegions);
      this.clusterDependFilterOptions = this.toNumberFilterOptions(data.dependClusters);
      this.omnichannelStrategyFilterOptions = this.toStrategyFilterOptions(data.strategies);
      this.typeFilterOptions = this.toTypeFilterOptions(data.types);
      this.gapFilterOptions = this.toNumberFilterOptions(data.gaps);
      this.depthFilterOptions = this.toNumberFilterOptions(data.depths);
      this.topEdgeFilterOptions = this.toNumberFilterOptions(data.topEdges);
      this.bottomEdgeFilterOptions = this.toNumberFilterOptions(data.bottomEdges);
      this.applyForPriceSegmentsFilterOptions = this.toBooleanFilterOptions(data.applyForPriceSegments);
      this.applyCompetitorPricesFilterOptions = this.toBooleanFilterOptions(data.applyCompetitorPrices);
      this.applyMinProfitabilityLimitFilterOptions = this.toBooleanFilterOptions(data.applyMinProfitabilityLimit);
    }

    private toNumberFilterOptions(options: Array<{ id: string; name: string }>): Array<SelectBox<number>> {
      return [
        this.defaultFilterValue,
        ...options.map((option) => ({
          value: Number(option.id),
          label: option.name,
        })),
      ];
    }

    private toBooleanFilterOptions(options: Array<{ id: string; name: string }>): Array<SelectBox<boolean | null>> {
      return [
        this.defaultStringFiltersValue,
        ...options.map((option) => {
          const value = option.id === 'true';
          return {
            value,
            label: this.toYesOrNoOmnichannel(value),
          };
        }),
      ];
    }

    private toStrategyFilterOptions(options: Array<{ id: string; name: string }>): Array<SelectBox<OmnichannelStrategy | null>> {
      const result: Array<SelectBox<OmnichannelStrategy | null>> = [
        { value: null, label: this.$tc('shared.selectBox.all') },
      ];
      options.forEach((option) => {
        const strategy = option.id as OmnichannelStrategy;
        if (this.omnichannelStrategiesSet[strategy]) {
          result.push(this.omnichannelStrategiesSet[strategy]);
        }
      });
      return result;
    }

    private toTypeFilterOptions(options: Array<{ id: string; name: string }>): Array<SelectBox<OmnichannelFixedGapType | null>> {
      const result: Array<SelectBox<OmnichannelFixedGapType | null>> = [this.defaultStringFiltersValue];
      options.forEach((option) => {
        const type = option.id as OmnichannelFixedGapType;
        if (this.omnichannelFixedDiffTypeSelectBox[type]) {
          result.push(this.omnichannelFixedDiffTypeSelectBox[type]);
        }
      });
      return result;
    }

    private mapRow(e: any): IOmnichannelStrategyTableElementDto {
      return {
        id: e.id,
        tradingNetId: e.tradingNetId,
        groupOfProduct: e.groupOfProduct,
        productCategory: e.productCategory,
        subcategory: e.subcategory,
        baseStoreParams: {
          cluster: e.baseStoreParams.cluster,
          format: e.baseStoreParams.format,
          region: e.baseStoreParams.region,
        },
        dependStoreParams: {
          cluster: e.dependStoreParams.cluster,
          format: e.dependStoreParams.format,
          region: e.dependStoreParams.region,
        },
        strategy: e.strategy,
        strategyParams: e.strategyParams,
      };
    }

    private clearFilterOptions() {
        this.gapFilterOptions = [];
        this.applyForPriceSegmentsFilterOptions = [];
        this.applyCompetitorPricesFilterOptions = [];
        this.applyMinProfitabilityLimitFilterOptions = [];
        this.subcategoryFilterOptions = [];
        this.categoryFilterOptions = [];
        this.groupFilterOptions = [];
        this.depthFilterOptions = [];
        this.bottomEdgeFilterOptions = [];
        this.topEdgeFilterOptions = [];
        this.typeFilterOptions = [];
        this.applyForPriceSegmentsFilterOptions = [];
        this.clusterDependFilterOptions = [];
        this.regionDependFilterOptions = [];
        this.clusterBaseFilterOptions = [];
        this.regionBaseFilterOptions = [];
        this.formatBaseFilterOptions = [];
        this.formatDependFilterOptions = [];
    }

    private setOmnichannelParameters(e: IOmnichannelStrategyTableElementDto) {
        let params = e.strategyParams;
        if (params !== null) {
            this.$log.log(params)
            const gap = this.gapFilterOptions.find((item) => {
                params = params as FixedDiffParams
                return item.value === (params as FixedDiffParams).gap
            })
            if (gap === undefined && (params as FixedDiffParams).gap !== null) {
                params = params as FixedDiffParams
                this.gapFilterOptions.push({
                    value: (params as FixedDiffParams).gap,
                    label: '' + (params as FixedDiffParams).gap,
                })
            }

            const type = this.typeFilterOptions.find((item) => {
                params = params as FixedDiffParams
                return item.value === (params as FixedDiffParams).type
            })
            if (type === undefined && (params as FixedDiffParams).type !== null) {
                params = params as FixedDiffParams
                this.typeFilterOptions.push({
                    value: (params as FixedDiffParams).type,
                    label: this.$tc(`labels.omnichannelStrategy.fixedGapTypes.${(params as FixedDiffParams).type}`),
                })
            }

            const priceSegments = this.applyForPriceSegmentsFilterOptions.find((item) => {
            return item.value === (params as FixedDiffParams).applyForPriceSegments
            })
            if (priceSegments === undefined && (params as FixedDiffParams).applyForPriceSegments !== null) {
              this.applyForPriceSegmentsFilterOptions.push({
                value: (params as FixedDiffParams).applyForPriceSegments,
                label: this.toYesOrNoOmnichannel((params as FixedDiffParams).applyForPriceSegments),
              })
            }
            const applyCompetitorPrices = this.applyCompetitorPricesFilterOptions.find((item) => {
              return item.value === ((params as FixedDiffParams).applyCompetitorPrices || (params as EqualityParams).applyCompetitorPrices || (params as OptimalDiffParams).applyCompetitorPrices)
            })
            if (applyCompetitorPrices === undefined && params.applyCompetitorPrices !== null) {
              this.applyCompetitorPricesFilterOptions.push({
                value: params.applyCompetitorPrices,
                label: this.toYesOrNoOmnichannel(params.applyCompetitorPrices),
              })
            }

            const applyMinProfitabilityLimit = this.applyMinProfitabilityLimitFilterOptions.find((item) => {
                return item.value === ((params as FixedDiffParams).applyMinProfitabilityLimit || (params as EqualityParams).applyMinProfitabilityLimit || (params as OptimalDiffParams).applyMinProfitabilityLimit)
            })
            if (applyMinProfitabilityLimit === undefined && (params as FixedDiffParams).applyMinProfitabilityLimit !== null) {
                this.applyMinProfitabilityLimitFilterOptions.push({
                    value: params.applyMinProfitabilityLimit,
                    label: this.toYesOrNoOmnichannel(params.applyMinProfitabilityLimit),
                })
            }
            const obj = this.depthFilterOptions.find((item) => {
              return item.value === (params as OptimalDiffParams).depth
            })
            if (obj === undefined && (params as OptimalDiffParams).depth !== null) {
              this.depthFilterOptions.push({
                value: (params as OptimalDiffParams).depth,
                label: '' + (params as OptimalDiffParams).depth,
              })
            }
            const bottomEdge = this.bottomEdgeFilterOptions.find((item) => {
              return item.value === (params as OptimalDiffParams).bottomEdge
            })
            if (bottomEdge === undefined && (params as OptimalDiffParams).bottomEdge !== null) {
              this.bottomEdgeFilterOptions.push({
                value: (params as OptimalDiffParams).bottomEdge,
                label: '' + (params as OptimalDiffParams).bottomEdge,
              })
            }
            const topEdge = this.topEdgeFilterOptions.find((item) => {
              return item.value === (params as OptimalDiffParams).topEdge
            })
            if (topEdge === undefined && (params as OptimalDiffParams).topEdge !== null) {
              this.topEdgeFilterOptions.push({
                value: (params as OptimalDiffParams).topEdge,
                label: '' + (params as OptimalDiffParams).topEdge,
              })
            }
        }
    }

    private setFilters(elementDto: IOmnichannelStrategyTableElementDto) {
        if (elementDto.dependStoreParams.format) {
            const obj = this.formatDependFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.dependStoreParams.format!.id
            })
            if (obj === undefined) {
                this.formatDependFilterOptions.push({
                    value: elementDto.dependStoreParams.format.id,
                    label: elementDto.dependStoreParams.format.name,
                })
            }
        }


        if (elementDto.dependStoreParams.region) {
            const obj = this.regionDependFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.dependStoreParams.region!.id
            })
            if (obj === undefined) {
                this.regionDependFilterOptions.push({
                    value: elementDto.dependStoreParams.region.id,
                    label: elementDto.dependStoreParams.region.name,
                })
            }
        }

        if (elementDto.dependStoreParams.cluster) {
            const obj = this.clusterDependFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.dependStoreParams.cluster!.id
            })
            if (obj === undefined) {
                this.clusterDependFilterOptions.push({
                    value: elementDto.dependStoreParams.cluster.id,
                    label: elementDto.dependStoreParams.cluster.name,
                })
            }
        }

        if (elementDto.baseStoreParams.format) {
            const obj = this.formatBaseFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.baseStoreParams.format!.id
            })
            if (obj === undefined) {
                this.formatBaseFilterOptions.push({
                    value: elementDto.baseStoreParams.format.id,
                    label: elementDto.baseStoreParams.format.name,
                })
            }
        }

        if (elementDto.baseStoreParams.region) {
            const obj = this.regionBaseFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.baseStoreParams.region!.id
            })
            if (obj === undefined) {
                this.regionBaseFilterOptions.push({
                    value: elementDto.baseStoreParams.region.id,
                    label: elementDto.baseStoreParams.region.name,
                })
            }
        }

        if (elementDto.baseStoreParams.cluster) {
            const obj = this.clusterBaseFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.baseStoreParams.cluster!.id
            })
            if (obj === undefined) {
                this.clusterBaseFilterOptions.push({
                    value: elementDto.baseStoreParams.cluster.id,
                    label: elementDto.baseStoreParams.cluster.name,
                })
            }
        }

        if (elementDto.subcategory) {
            const obj = this.subcategoryFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.subcategory!.id
            })
            if (obj === undefined) {
                this.subcategoryFilterOptions.push({
                    value: elementDto.subcategory.id,
                    label: elementDto.subcategory.name,
                })
            }
        }

        if (elementDto.productCategory) {
            const obj = this.categoryFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.productCategory!.id
            })
            if (obj === undefined) {
                this.categoryFilterOptions.push({
                    value: elementDto.productCategory.id,
                    label: elementDto.productCategory.name,
                })
            }
        }

        if (elementDto.groupOfProduct) {
            const obj = this.groupFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.groupOfProduct!.id
            })
            if (obj === undefined) {
                this.groupFilterOptions.push({
                    value: elementDto.groupOfProduct.id,
                    label: elementDto.groupOfProduct.name,
                })
            }
        }

        if (elementDto.strategy) {
            const obj = this.omnichannelStrategyFilterOptions.find((item) => {
                // tslint:disable-next-line: no-non-null-assertion
                return item.value === elementDto.strategy
            })
            if (obj === undefined) {
                this.omnichannelStrategyFilterOptions.push({
                    value: elementDto.strategy,
                    label: elementDto.strategy,
                })
            }
        }

        this.setOmnichannelParameters(elementDto);

        this.regionBaseFilterOptions = this.regionBaseFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.regionBaseFilterOptions.unshift(this.defaultFilterValue)

        this.clusterBaseFilterOptions = this.clusterBaseFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.clusterBaseFilterOptions.unshift(this.defaultFilterValue)

        this.formatBaseFilterOptions = this.formatBaseFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.formatBaseFilterOptions.unshift(this.defaultFilterValue)

        this.formatDependFilterOptions = this.formatDependFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.formatDependFilterOptions.unshift(this.defaultFilterValue)

        this.regionDependFilterOptions = this.regionDependFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.regionDependFilterOptions.unshift(this.defaultFilterValue)

        this.clusterDependFilterOptions = this.clusterDependFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.clusterDependFilterOptions.unshift(this.defaultFilterValue)

        this.categoryFilterOptions = this.categoryFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.categoryFilterOptions.unshift(this.defaultFilterValue)

        this.subcategoryFilterOptions = this.subcategoryFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.subcategoryFilterOptions.unshift(this.defaultFilterValue)

        this.groupFilterOptions = this.groupFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.groupFilterOptions.unshift(this.defaultFilterValue)

        this.gapFilterOptions = this.gapFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.gapFilterOptions.unshift(this.defaultFilterValue)

        this.typeFilterOptions = this.typeFilterOptions.filter((e) => e.value !== this.defaultStringFiltersValue.value)
        this.typeFilterOptions.unshift(this.defaultStringFiltersValue)

        this.applyForPriceSegmentsFilterOptions = this.applyForPriceSegmentsFilterOptions.filter((e) => e.value !== this.defaultStringFiltersValue.value)
        this.applyForPriceSegmentsFilterOptions.unshift(this.defaultStringFiltersValue)

        this.applyCompetitorPricesFilterOptions = this.applyCompetitorPricesFilterOptions.filter((e) => e.value !== this.defaultStringFiltersValue.value)
        this.applyCompetitorPricesFilterOptions.unshift(this.defaultStringFiltersValue)

        this.applyMinProfitabilityLimitFilterOptions = this.applyMinProfitabilityLimitFilterOptions.filter((e) => e.value !== this.defaultStringFiltersValue.value)
        this.applyMinProfitabilityLimitFilterOptions.unshift(this.defaultStringFiltersValue)

        this.topEdgeFilterOptions = this.topEdgeFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.topEdgeFilterOptions.unshift(this.defaultFilterValue)

        this.bottomEdgeFilterOptions = this.bottomEdgeFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.bottomEdgeFilterOptions.unshift(this.defaultFilterValue)

        this.depthFilterOptions = this.depthFilterOptions.filter((e) => e.value !== this.defaultFilterValue.value)
        this.depthFilterOptions.unshift(this.defaultFilterValue)
    }

    private editStrategy(strategy: IOmnichannelStrategyTableDto) {
      let actualStrategyParams: FixedDiffParams | OptimalDiffParams | EqualityParams | null = null;
      let tmpStrategyParams: FixedDiffParams | OptimalDiffParams | EqualityParams | null = null;
      switch (strategy.strategy) {
        case OmnichannelStrategy.PRICE_EQUALITY:
          tmpStrategyParams = strategy.strategyParams as EqualityParams;
          actualStrategyParams = new EqualityParams(tmpStrategyParams.applyCompetitorPrices, tmpStrategyParams.applyMinProfitabilityLimit)
          break;
        case OmnichannelStrategy.FIXED_DIFFERENCE:
          tmpStrategyParams = strategy.strategyParams as FixedDiffParams;
          actualStrategyParams = new FixedDiffParams((tmpStrategyParams as FixedDiffParams).type, (tmpStrategyParams as FixedDiffParams).gap, (tmpStrategyParams as FixedDiffParams).applyForPriceSegments, tmpStrategyParams.applyCompetitorPrices, tmpStrategyParams.applyMinProfitabilityLimit);
          break;
        case OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML:
          tmpStrategyParams = strategy.strategyParams as OptimalDiffParams;
          actualStrategyParams = new OptimalDiffParams((tmpStrategyParams as OptimalDiffParams).bottomEdge, (tmpStrategyParams as OptimalDiffParams).topEdge, (tmpStrategyParams as OptimalDiffParams).depth, tmpStrategyParams.applyCompetitorPrices, tmpStrategyParams.applyMinProfitabilityLimit);
          break;
      }
      const obj: IOmnichannelStrategySaveDto = {
            id: strategy.id,
            strategy: strategy.strategy,
            baseStoreParams: {
                clusterId: strategy.baseStoreParams.cluster ? strategy.baseStoreParams.cluster.id : null,
                formatId: strategy.baseStoreParams.format ? strategy.baseStoreParams.format.id : null,
                regionId: strategy.baseStoreParams.region ? strategy.baseStoreParams.region.id : null,
            },
            dependStoreParams: {
                clusterId: strategy.dependStoreParams.cluster ? strategy.dependStoreParams.cluster.id : null,
                formatId: strategy.dependStoreParams.format ? strategy.dependStoreParams.format.id : null,
                regionId: strategy.dependStoreParams.region ? strategy.dependStoreParams.region.id : null,
            },
            categoryId: strategy.productCategory ? strategy.productCategory.id : null,
            groupId: strategy.groupOfProduct ? strategy.groupOfProduct.id : null,
            subcategoryId: strategy.subcategory ? strategy.subcategory.id : null,
            strategyParams: actualStrategyParams,
            tradingNetId: strategy.tradingNetId,
        };
      this.fetchStrategies({}, () => {});
      this.$emit('editStrategy', obj);
    }

    private deleteStrategy(strategy: IOmnichannelStrategyDto) {
        this.$bvModal.msgBoxConfirm(this.$tc('omnichannelStrategy.deleteConfirmText'), {
            headerBgVariant: 'warning',
            title: this.$tc('shared.messages.attention'),
            size: 'sm',
            buttonSize: 'sm',
            okTitle: this.$tc('shared.buttons.yes'),
            cancelTitle: this.$tc('shared.buttons.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            noCloseOnEsc: true,
            noCloseOnBackdrop: true,
            centered: true,
        })
                .then((value) => {
                    if (value) {
                        if (strategy.id != null) {
                            this.api.deleteStrategy(strategy.id)
                                    .then((resp) => {
                                        if (resp.status === 204) {
                                            this.fetchStrategies({}, () => {});
                                            (this.$refs.strategiesTable as any).$forceUpdate()
                                        }
                                    })
                                    .catch(() => {
                                        // todo: show error
                                    });
                        }
                    } else {
                    }
                })

    }

    goToProductList(strategy: IOmnichannelStrategyTableDto): void {
      this.$emit('goToProductList', strategy);
    }

  downloadErrors() {
    if (!this.filters.market) {
      this.showError(this.$tc('omnichannelStrategy.messages.selectTradingCampaign'));
      return;
    }

    this.api.getOmnichannelStrategiesImportErrors(this.filters.market.id)
        .then((response) => {
          if (!response.data || (typeof response.data === 'string' && !response.data.trim())) {
            this.showInfo(this.$tc('omnichannelStrategy.messages.noErrors'));
            return;
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          link.setAttribute('download', this.$tc('omnichannelStrategy.messages.importErrorsFilename'));
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        })
  }

  exportData() {
    if (!this.filters.market) {
      this.showError(this.$tc('omnichannelStrategy.messages.selectTradingCampaign'));
      return;
    }

    const auth = localStorage.getItem('AUTH');
    if (!auth) {
      this.showError(this.$tc('omnichannelStrategy.messages.authError'));
      return;
    }

    const { user_id: userId } = JSON.parse(auth);
    this.api.exportOmnichannelStrategies(this.filters.market.id, userId)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.$tc('omnichannelStrategy.messages.exportFilename'));
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        })
  }

  fetchAllData() {
    this.refreshOmnicalStrategyListBySelectedFilters();
    this.getErrorsAmount();
  }

  getErrorsAmount() {
    if (!this.filters.market) {
      return;
    }
    this.api.getLastFileErrorsAmount(this.filters.market.id, 'OMNICHANNEL_STRATEGIES')
        .then((r) => {
          this.errorsAmount = r.data;
        });
  }

  uploadWithFileForComponent(file: File, uploadOption: ImportUploadOption): Promise<void> {
    if (!this.filters.market) {
      return Promise.reject(new Error(this.$tc('omnichannelStrategy.messages.selectTradingCampaign')));
    }
    const uploadFile = new FormData();
    uploadFile.append('file', new Blob([file]), file.name);
    return this.api.uploadOmnichannelStrategiesFile(this.filters.market.id, uploadFile, uploadOption).then(() => {});
  }

  onUploadPartialForComponent(file: File): Promise<void> {
    return this.uploadWithFileForComponent(file, ImportUploadOption.UPDATE);
  }

  onUploadFullForComponent(file: File): Promise<void> {
    return this.uploadWithFileForComponent(file, ImportUploadOption.FULL_UPDATE);
  }

  getUploadStatusForComponent(): Promise<{ status: string; progress?: number }> {
    if (!this.filters.market) {
      return Promise.reject(new Error(this.$tc('omnichannelStrategy.messages.noTradingCampaign')));
    }
    return this.api.getOmnichannelStrategiesUploadStatus(this.filters.market.id).then((res) => ({
      status: res.data.status,
      progress: res.data.progress != null ? res.data.progress : undefined,
    }));
  }
}
